import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  CircularProgress,
  Alert
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import paymentService from '../services/paymentService';

const PaymentResultPage = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (paymentId) {
      checkPaymentStatusAndRedirect();
    } else {
      setError('Payment ID is required');
      setLoading(false);
    }
  }, [paymentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkPaymentStatusAndRedirect = async () => {
    try {
      setLoading(true);

      // Fetch payment status
      const paymentData = await paymentService.getPaymentStatus(paymentId);

      // Redirect based on payment status with payment data
      if (paymentData.status === 'completed') {
        navigate(`/payment/success/${paymentId}`, {
          replace: true,
          state: { paymentData }
        });
      } else if (paymentData.status === 'failed') {
        navigate(`/payment/failed/${paymentId}`, {
          replace: true,
          state: { paymentData }
        });
      } else {
        // Handle other statuses (pending, processing, etc.)
        setError(`Payment is currently ${paymentData.status}. Please wait or contact support.`);
        setLoading(false);
      }

    } catch (err) {
      console.error('Error checking payment status:', err);
      setError('Failed to check payment status. Please try again.');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh', justifyContent: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Box sx={{ textAlign: 'center' }}>
            Checking payment status...
          </Box>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mt: 4 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return null; // This should not render as we redirect
};

export default PaymentResultPage;
